import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import { TabsCategories } from '../..';
import { useSelector, useDispatch } from 'react-redux'
import { getScheduleSelected } from '../../../helpers/getScheduleSelected';
import { setStartEndDate } from '../../../helpers/setStartEndDate';
import { setStartEndDateBp } from '../../../helpers/setStartEndDateBp';
import { numberFormat } from '../../../helpers/numberFormat';
import { numberToDateString } from '../../../helpers/numberToDateString';
import {
    IconSquareRoundedPlusFilled,
    IconTrash
} from '@tabler/icons-react';

const RegistrationPageTwoComp = (props) => {

    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    const dispatch = useDispatch()
    const bpSelected = useSelector(state => state.bpSelected)
    const programSelected = useSelector(state => state.programSelected)
    const bpScheduleSelected = useSelector(state => state.bpScheduleSelected)
    const scheduleSelected = useSelector(state => state.scheduleSelected)
    const dataInputRegistration = useSelector(state => state.dataInputRegistration)

    const [showAddProgram, setShowAddProgram] = useState(false);

    const handleCloseKatalogProgram = () => {
        setShowAddProgram(false)
    }

    const handleDeleteProgramSelected = (obj) => {
        dispatch({ type: 'UNSET_PROGRAM_SELECTED', payload: obj });

        const payload = { 'programId': obj.id }
        dispatch({ type: 'UNSET_SCHEDULE_SELECTED', payload: payload });

        dispatch({ type: 'UNSET_PARTICIPANT_IN_PROGRAM', payload: payload });

    }

    const handleChangeSchedule = (e, programId) => {
        const dateOfSchedule = setStartEndDate(programSelected, programId, e.target.value)
        // console.log(dateOfSchedule)
        let checkSchedule = scheduleSelected.find(row => programId === row.programId)
        // console.log(checkSchedule)

        if (checkSchedule === undefined) {
            const obj = {
                'programId': programId,
                'scheduleId': e.target.value,
                'startDate': dateOfSchedule.startDate,
                'endDate': dateOfSchedule.endDate,
                'participants': []
            }
            dispatch({ type: 'SET_SCHEDULE_SELECTED', payload: obj });
        } else {
            const payload = { 'programId': programId }
            dispatch({ type: 'UNSET_SCHEDULE_SELECTED', payload: payload });

            const obj = {
                'programId': programId,
                'scheduleId': e.target.value,
                'startDate': dateOfSchedule.startDate,
                'endDate': dateOfSchedule.endDate,
                'participants': []
            }
            dispatch({ type: 'SET_SCHEDULE_SELECTED', payload: obj });
        }


    }

    // const handleDeleteBpSelected = (obj) => {
    //     // console.log(obj)
    //     // return false
    //     dispatch({ type: 'UNSET_BP_SELECTED', payload: obj });

    //     const payload = { 'id': obj.id }
    //     dispatch({ type: 'UNSET_BP_SCHEDULE_SELECTED', payload: payload });

    //     dispatch({ type: 'UNSET_BP_PARTICIPANT_IN_PROGRAM', payload: payload });

    // }

    const handleDeleteBpSelected = (obj) => {
        // console.log(obj.id)
        // return false
        
        dispatch({ type: 'UNSET_BP_SELECTED', payload: obj });
       
        const payload1 = { 'bpId': obj.id }
        dispatch({ type: 'UNSET_BP_SCHEDULE_SELECTED', payload: payload1 });
        // dispatch({ type: 'UNSET_BP_PARTICIPANT_IN_PROGRAM', payload: payload2 });

    }

    const handleChangeScheduleBp = (e, bpId, programId) => {
        const dateOfSchedule = setStartEndDateBp(bpSelected, programId, e.target.value)
        // console.log(dateOfSchedule)
        // return false
        const obj = {
            'bpId': bpId,
            'programId': programId,
            'scheduleId': e.target.value,
            'startDate': dateOfSchedule.startDate,
            'endDate': dateOfSchedule.endDate,
            'participants': []
        }
        dispatch({ type: 'SET_BP_SCHEDULE_SELECTED', payload: obj });
    }

    // console.log(bpSelected)
    // console.log(bpScheduleSelected)

    return (
        <>
            <div className='col-lg-12'>
                {
                    size.width < 500 ?
                        <h5>Informasi Program</h5>
                        :
                        <h3 style={{ fontSize: '20px' }}>Informasi Program</h3>
                }
                <hr style={{ marginBottom: '3%', marginTop: '3%' }}></hr>
                {
                    size.width < 500 ?
                        <>
                            <div className='col-12 mt-3 mb-3'>
                                <p style={{ fontSize: size.width < 500 ? '10px' : '13px', marginBottom: '3%' }}>Pilih program yang diikuti</p>
                            </div>
                            <div className='col-12 mt-3 mb-3' style={{ textAlign: 'right' }}>
                                <button style={{ fontWeight: '400', backgroundColor: '#0C86D9', color: '#F2F2F2' }} onClick={() => setShowAddProgram(true)} className="btn btn-primary">
                                    <IconSquareRoundedPlusFilled
                                        width={28}
                                        height={28}
                                    /> Tambah Program</button>
                            </div>
                        </>
                        :
                        <>
                            <div className='d-flex justify-content-between'>
                                <p style={{ fontSize: size.width < 500 ? '13px' : '16px', fontWeight: '400', marginBottom: '3%' }}>Pilih program yang diikuti</p>
                                <button style={{ fontSize: size.width < 500 ? '13px' : '16px', fontWeight: '400', backgroundColor: '#0C86D9', color: '#F2F2F2' }} onClick={() => setShowAddProgram(true)} className="btn btn-primary"><IconSquareRoundedPlusFilled
                                    width={28}
                                    height={28}
                                />&nbsp; Tambah Program</button>
                            </div>
                        </>
                }

            </div>
            {
                dataInputRegistration.inputAlert === true ?
                    <div className='col-lg-12'>
                        <p style={{ color: '#F1416C', fontSize: size.width < 500 ? '13px' : '16px', fontWeight: '400' }}>Silahkan tambah program!</p>
                    </div>
                    :
                    ''
            }
            <div className='col-lg-12' style={{ marginTop: '3%' }}>
                {
                    programSelected.length > 0 ||
                        bpSelected.length > 0
                        ?
                        <>
                            {
                                programSelected.map((ps, j) =>
                                    <div className="card" style={{ marginBottom: '4%' }}>
                                        <div className="card-body">
                                            <div className='row'>

                                                {
                                                    size.width > 500 ?
                                                        <>
                                                            <div className='col-lg-6 col-12'>
                                                                <h6 style={{ fontSize: size.width < 500 ? '13px' : '16px', fontWeight: '600' }}>{ps.name}</h6>
                                                            </div>
                                                            <div className='col-lg-5 col-12'>
                                                                <h6 style={{ fontSize: size.width < 500 ? '11px' : '15px', fontWeight: '600' }}>Pilih Jadwal Program</h6>
                                                            </div>
                                                            <div className='col-lg-1 col-12'>
                                                                <IconTrash
                                                                    width={28}
                                                                    height={28}
                                                                    className='text-danger'
                                                                    type='button'
                                                                    onClick={(e) => handleDeleteProgramSelected(ps)}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        ''
                                                }

                                            </div>
                                            {
                                                size.width < 500 ?
                                                    <>
                                                        <div className='row d-flex justify-content-around'>
                                                            <div className='col-10'>
                                                                <h6>{ps.name}</h6>
                                                            </div>
                                                            <div className='col-2'>
                                                                <IconTrash
                                                                    width={24}
                                                                    height={24}
                                                                    className='text-danger'
                                                                    type='button'
                                                                    onClick={(e) => handleDeleteProgramSelected(ps)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    ''
                                            }

                                            <div className='row mt-2'>
                                                <div className='col-lg-6 d-flex'>
                                                    <h5 style={{ color: '#0C86D9', fontSize: size.width < 500 ? '11px' : '15px', fontWeight: '600' }}>Rp. {numberFormat(ps?.Pricebooks[0]?.price)}</h5>
                                                    <p style={{ fontStyle: 'italic', fontSize: '12px' }}>&nbsp;(* belum termasuk PPN 11%)</p>
                                                </div>
                                                <div className='col-lg-5'>
                                                    {
                                                        size.width < 500 ?
                                                            <h6>Pilih Jadwal Program</h6>
                                                            :
                                                            ''
                                                    }
                                                    <select className="form-select" aria-label="Select example" onChange={(e) => handleChangeSchedule(e, ps.id)} value={getScheduleSelected(scheduleSelected, ps.id)}>
                                                        <option>Pilih</option>
                                                        {
                                                            ps.Schedules.map((schedule, j) =>
                                                                <option value={schedule.id}>{numberToDateString(schedule.startDate)} s/d {numberToDateString(schedule.endDate)}</option>
                                                            )
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            {
                                                size.width < 500 ?
                                                    <div className='row mt-3'>
                                                        <div className='col-lg-12'>
                                                            <span className="badge" style={{ backgroundColor: '#26D07C', color: '#F2F2F2' }}>Available</span>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className='row'>
                                                        <div className='col-lg-12'>
                                                            <span className="badge" style={{ backgroundColor: '#26D07C', color: '#F2F2F2' }}>Available</span>
                                                        </div>
                                                    </div>
                                            }

                                        </div>
                                    </div>
                                )
                            }

                            {
                                bpSelected.map((bps, j) =>
                                    <div className="card" style={{ marginBottom: '4%' }}>
                                        <div className="card-body">
                                            <div className='row mb-4'>
                                                {
                                                    size.width > 500 ?
                                                        <>
                                                            <div className='col-lg-6 col-12'>
                                                                <h6 style={{ fontSize: size.width < 500 ? '13px' : '16px', fontWeight: '600', color: '#0C86D9' }}>{bps.name} (Bundling) <span className="badge" style={{ backgroundColor: '#26D07C', color: '#F2F2F2' }}>Available</span></h6>
                                                            </div>
                                                            <div className='d-flex col-lg-5 col-12'>
                                                                <h5 style={{ color: '#0C86D9', fontSize: size.width < 500 ? '11px' : '15px', fontWeight: '600' }}>Rp. {numberFormat(bps.price)}</h5>
                                                                <p style={{ fontStyle: 'italic', fontSize: '12px' }}>&nbsp;(* belum termasuk PPN 11%)</p>
                                                            </div>
                                                            <div className='col-lg-1 col-12'>
                                                                <IconTrash
                                                                    width={28}
                                                                    height={28}
                                                                    className='text-danger'
                                                                    type='button'
                                                                    onClick={(e) => handleDeleteBpSelected(bps)}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        ''
                                                }
                                            </div>
                                            {
                                                size.width < 500 ?
                                                    <>
                                                        <div className='row d-flex justify-content-around'>
                                                            <div className='col-10'>
                                                                <h6>{bps.name}</h6>
                                                            </div>
                                                            <div className='col-2'>
                                                                <IconTrash
                                                                    width={24}
                                                                    height={24}
                                                                    className='text-danger'
                                                                    type='button'
                                                                    onClick={(e) => handleDeleteBpSelected(bps)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    ''
                                            }

                                            <div className='row'>
                                                {
                                                    bps?.BundlingProgramItems.map((item) =>
                                                        <>
                                                            <div className='col-lg-6 col-12 mb-3'>
                                                                <h6 style={{ fontSize: size.width < 500 ? '13px' : '16px', fontWeight: '600' }}>{item.Program.name}</h6>
                                                            </div>
                                                            <div className='col-lg-5 col-12 mb-3'>
                                                                <h6 className='mb-1' style={{ fontSize: size.width < 500 ? '13px' : '16px', fontWeight: '600' }}>Pilih Jadwal Program</h6>
                                                                <select className='form-control' onChange={(e) => handleChangeScheduleBp(e, bps.id, item.Program.id)} value={getScheduleSelected(bpScheduleSelected, item.Program.id)}>
                                                                    <option value="">- Pilih -</option>
                                                                    {
                                                                        item?.Program?.Schedules.map((schedule) =>
                                                                            <option value={schedule.id}>
                                                                                {numberToDateString(schedule.startDate)} s/d {numberToDateString(schedule.endDate)}
                                                                            </option>
                                                                        )}
                                                                </select>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </>
                        :
                        <>
                            <div className="card">
                                <div className="card-body" style={{ textAlign: 'center' }}>
                                    <h6 style={{ color: '#F1416C', fontSize: size.width < 500 ? '13px' : '16px', fontWeight: '600' }}>Anda belum memilih program</h6>
                                    <p style={{ fontSize: size.width < 500 ? '12px' : '14px' }}>
                                        Klik tombol <b>"Tambah Program"</b> untuk memilih program.
                                        <br /> <b>Anda dapat memilih program lebih dari satu program.</b>
                                    </p>
                                </div>
                            </div>
                        </>
                }
            </div >

            <Modal
                show={showAddProgram}
                size='xl'
                onHide={() => setShowAddProgram(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title className='ms-auto' style={{ margin: 'auto', textAlign: 'center' }}>
                        <div className='mt-3 mb-3'>
                            <h2 className='mb-1' style={{ color: '#0C86D9' }}>Katalog Program</h2>
                            <p style={{ fontWeight: '700', fontSize: size.width < 500 ? '13px' : '15px' }}>Anda dapat memilih lebih dari 1 program yang ingin Anda ikuti !</p>
                        </div>
                    </Modal.Title>
                </Modal.Header >
                <Modal.Body>
                    <TabsCategories
                        close={handleCloseKatalogProgram}
                    />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default RegistrationPageTwoComp
